export const MacroToolRoutesConfig = {
  countryLevelAnalytics: "/country-level-analytics",
  scenarioPage: "/country-level-analytics/scenario/:id",
  adjustmentsPage: "/country-level-analytics/scenario/:id/adjustments",
  createAdjustment: "/country-level-analytics/scenario/:id/adjustments/create",
  editAdjustment:
    "/country-level-analytics/scenario/:id/adjustments/:adjustmentId/edit",
  compareScenarioPage: "/country-level-analytics/compare-scenario",
};
